import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import TermsBody from './TermsBody/TermsBody';

const Terms = () => {
    return (
        <div className="terms-view">
            <Helmet>
                <title>HPP&apos;s Terms and Conditions | Hudson Pacific Properties</title>
                <meta name="description" property="og:description" content="Read Hudson Pacific Properties Terms and Conditions here." />
            </Helmet>
            <Hero />
            <TermsBody />
        </div>
    );
};

export default Terms;
